$(document).ready(function () {
  if (
    $(".sub_policy_block").first().find("a").first().text() == "Account Portal"
  ) {
    $(".sub_policy_block").first().find("a").first().addClass("button");
    // $(".sub_policy_block").first().find("a").first().css("display","inline-flex");
  }
  
  $(".right-image-desc .main-product-parent-header").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  $(".left-heading-desc .main-product-parent-header").slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  $(document).on("click", "header .toggle-menu-link-mobile", function () {
    $(this).parents(".single-menu-drawer").toggleClass("active-dropdown");
    $(this)
      .parents(".single-menu-drawer")
      .find(".main-collections-parent")
      .slideToggle();
  });
  $(document).on("click", "header .close-mobile-drawer-menu", function () {
    $("header-drawer summary.header__icon.header__icon--menu").click();
  });
  $(document).on("click", "header .left-search", function () {
    $("header-drawer summary.header__icon.header__icon--menu").click();
    $("header .header__search summary.header__icon--search").click();
  });
  $(document).on(
    "click",
    "footer .footer-block--menu .footer-block__heading",
    function () {
      $(this).parent().toggleClass("active-dropdown-footer");
      $(this).next("ul").slideToggle();
    }
  );
  $(document).on("click", ".subpol_title", function () {
    $(this).parent().toggleClass("active_title");
    $(this).next(".block_p").slideToggle();
  });
  $(".section-insta-landing .parent-div-instagram-data").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    appendArrows: $(".section-insta-landing .slick-slider-nav"),
    appendDots: $(".section-insta-landing .slick-slider-dots"),

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true,
        },
      },
    ],
  });
  $(".collection-with-slider ul.product-grid").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    appendArrows: $(".collection-with-slider .slick-slider-nav"),
    appendDots: $(".collection-with-slider .slick-slider-dots"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true,
          centerMode: true,
          centerPadding: "60px",
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true,
          centerMode: true,
          centerPadding: "30px",
        },
      },
    ],
  });
  $(".section-real-result .main-content-slider-result").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    appendArrows: $(".section-real-result .slick-slider-nav"),
    appendDots: $(".section-real-result .slick-slider-dots"),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true,
        },
      },
    ],
  });
  $(".section-hair-care .main-content-slider-section-hair-care").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    appendArrows: $(".section-hair-care .slick-slider-nav"),
    appendDots: $(".section-hair-care .slick-slider-dots"),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: true,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          arrows: true,
          dots: true,
        },
      },
    ],
  });
  $(document).on("click", ".heading-new", function () {
    // if(!$(this).parents(".collapsible-content-hp").hasClass("collapsible-content-pdp")){
    $(this)
      .parents(".accordion-new")
      .find(".heading-new")
      .not(this)
      .removeClass("active");
    // }
    $(this).toggleClass("active").next().slideToggle();
    // if(!$(this).parents(".collapsible-content-hp").hasClass("collapsible-content-pdp")){
    $(this)
      .parents(".accordion-new")
      .find(".contents-new")
      .not($(this).next())
      .slideUp(300);
    // }
  });
  $(document).on("click", "p.read-more-less", function () {
    if ($(this).text() == "Read Less") {
      $(this).parent().find(".small-content").show();
      $(this).parent().find(".large-content").hide();
      $(this).text("Keep Reading");
    } else {
      $(this).parent().find(".small-content").hide();
      $(this).parent().find(".large-content").show();
      $(this).text("Read Less");
    }
  });
  $(document).on(
    "click",
    ".section-hair-loss .single-tabs-hair-loss",
    function () {
      $(this)
        .parents(".section-hair-loss")
        .find(".single-tabs-hair-loss")
        .removeClass("active-hp-tab");
      $(this).addClass("active-hp-tab");
      $(this)
        .parents(".section-hair-loss")
        .find(".single-slide-hair-loss")
        .hide();
      $(this)
        .parents(".section-hair-loss")
        .find("#" + $(this).attr("tab-show-attr"))
        .show();
    }
  );
  $(document).on("click", ".video-play-pause", function () {
    $(this).hide();
    $(
      ".section-hair-care .main-content-slider-section-hair-care video"
    ).trigger("pause");
    $(this).parent().find("video").trigger("play");
  });
  $(".section-hair-care video").on("pause", function () {
    $(this).parent().find(".video-play-pause").show();
  });
  $(".section-hair-care video").on("playing", function () {
    $(this).parent().find(".video-play-pause").hide();
  });
  $(".section-hair-care .main-content-slider-section-hair-care").on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      $(
        ".section-hair-care .main-content-slider-section-hair-care video"
      ).trigger("pause");
    }
  );
  $(document).on("click", ".section-hair-care video", function () {
    $(this).parent().find("video").trigger("pause");
  });
  $(".size-dropdown-parent").on("click", function () {
    $(this)
      .parents(".size-option-with-dropdown")
      .find(".size-option-details")
      .slideToggle();
    $(this).toggleClass("active-size-variant");
  });
  $(".size-option-details p").on("click", function () {
    var variantsize = $(this).attr("data-value-size");
    $("#SortBy").val(variantsize);
    $("#SortBy").trigger("change");
    $("#FacetFiltersForm").submit();
  });
  $(document).on("click", function (event) {
    if (!$(event.target).closest(".size-option-with-dropdown").length) {
      if ($(".size-dropdown-parent").hasClass("active-size-variant")) {
        $(".size-dropdown-parent").removeClass("active-size-variant");
        $(".size-option-details").slideUp();
      }
    }
  });
  $(document).on("click", ".read-more-ingredients p", function () {
    $(this).parents(".read-more-ingredients").hide();
    $(".product-ingredients-pdp .single-content-ingredients").addClass(
      "show-indredients-data"
    );
  });
  $(document).on("click", ".both-tab-bundle p", function () {
    $(this).parent().find("p").removeClass("active-bundle-tab");
    $(this).addClass("active-bundle-tab");
    $(".tab-data-bundle .single-tab-data").removeClass("active-tab-detail");
    if ($(this).hasClass("subscription-bundle")) {
      $(".tab-data-bundle .subscription-bundle-data").addClass(
        "active-tab-detail"
      );
      $(".prod-price").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".subscription-bundle-data .single-product-data.selected-plan .final-product-price"
          )
          .text()
      );
      $(".prod-compare-price").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".subscription-bundle-data .single-product-data.selected-plan .original-product-price"
          )
          .text()
      );
      $(".save-percent").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".subscription-bundle-data .single-product-data.selected-plan .pdp-save-amount"
          )
          .text()
      );
      $(".product-form__submit .product-price-total-btn").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".subscription-bundle-data .single-product-data.selected-plan .final-product-price"
          )
          .text()
      );
      $(".product product-form .product-variant-id").val(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".subscription-bundle-data .single-product-data.selected-plan")
          .attr("data-varint-id")
      );
      $(".product product-form .product-selling-plan-id").val(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".subscription-bundle-data .single-product-data.selected-plan")
          .attr("data-subscription-id")
      );
      $(".prod-gift-box").addClass("locked");
      $.each(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".subscription-bundle-data .single-product-data.selected-plan")
          .attr("data-gifts")
          .split("::"),
        function (i, cls) {
          cls = $.trim(cls);
          if (!cls) {return true}; //skip empty value
          $(`.prod-gift-box.${cls}`).removeClass("locked");
        }
      );
      $(".prod-value-points__title.sub").css("display", "block");
      $(".prod-value-points__title.otp").css("display", "none");
      if (
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".subscription-bundle-data .single-product-data.selected-plan")
          .attr("data-product-avail") == "true"
      ) {
        $(".product .add-soldout-text").text("Add To Cart");
        $(".product .product-form__buttons .product-form__submit").removeAttr(
          "disabled",
          ""
        );
      } else {
        $(".product .add-soldout-text").text("Sold Out");
        $(".product .product-form__buttons .product-form__submit").attr(
          "disabled",
          ""
        );
      }
      if ($(".product__info-wrapper").hasClass("commin-soon-product")) {
        $(".product .add-soldout-text").text("Coming Soon");
      }
      if (
        $(".product .product-form__buttons").hasClass("notify-popup-trigger")
      ) {
        $(".product .add-soldout-text").text("COMING SOON - NOTIFY WHEN READY");
      }
    } else {
      $(".tab-data-bundle .one-time-bundle-data").addClass("active-tab-detail");
      $(".prod-price").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".one-time-bundle-data .single-product-data.selected-plan .final-product-price"
          )
          .text()
      );
      $(".prod-compare-price").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".one-time-bundle-data .single-product-data.selected-plan .original-product-price"
          )
          .text()
      );
      $(".save-percent").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".one-time-bundle-data .single-product-data.selected-plan .pdp-save-amount"
          )
          .text()
      );
      $(".product-form__submit .product-price-total-btn").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".one-time-bundle-data .single-product-data.selected-plan .final-product-price"
          )
          .text()
      );

      $(".product product-form .product-variant-id").val(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".one-time-bundle-data .single-product-data.selected-plan")
          .attr("data-varint-id")
      );
      $(".product product-form .product-selling-plan-id").val(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".one-time-bundle-data .single-product-data.selected-plan")
          .attr("data-subscription-id")
      );
      $(".prod-gift-box").addClass("locked");
      $.each(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".one-time-bundle-data .single-product-data.selected-plan")
          .attr("data-gifts")
          .split("::"),
        function (i, cls) {

          cls = $.trim(cls);
          if (!cls) {return true}; //skip empty value
          $(`.prod-gift-box.${cls}`).removeClass("locked");
        }
      );
      $(".prod-value-points__title.sub").css("display", "none");
      $(".prod-value-points__title.otp").css("display", "block");
      if (
        $(this)
          .parents(".custom-bundle-pdp")
          .find(".one-time-bundle-data .single-product-data.selected-plan")
          .attr("data-product-avail") == "true"
      ) {
        $(".product .add-soldout-text").text("Add To Cart");
        $(".product .product-form__buttons .product-form__submit").removeAttr(
          "disabled",
          ""
        );
      } else {
        $(".product .add-soldout-text").text("Sold Out");
        $(".product .product-form__buttons .product-form__submit").attr(
          "disabled",
          ""
        );
      }
      if ($(".product__info-wrapper").hasClass("commin-soon-product")) {
        $(".product .add-soldout-text").text("Coming Soon");
      }
      if (
        $(".product .product-form__buttons").hasClass("notify-popup-trigger")
      ) {
        $(".product .add-soldout-text").text("COMING SOON - NOTIFY WHEN READY");
      }
    }
  });
  $(document).on("click", ".single-product-data", function () {
    $(this).parent().find(".single-product-data").removeClass("selected-plan");
    $(this).addClass("selected-plan");

    $(".prod-price").text($(this).find(".final-product-price").text());
    $(".prod-compare-price").text(
      $(this).find(".original-product-price").text()
    );
    $(".save-percent").text($(this).find(".pdp-save-amount").text());
    $(".product-form__submit .product-price-total-btn").text(
      $(this).find(".final-product-price").text()
    );
    $(".product product-form .product-variant-id").val(
      $(this).attr("data-varint-id")
    );
    $(".product product-form .product-selling-plan-id").val(
      $(this).attr("data-subscription-id")
    );
    $(".prod-gift-box").addClass("locked");
    $.each($(this).attr("data-gifts").split("::"), function (i, cls) {
      $(`.prod-gift-box.${cls}`).removeClass("locked");
    });
    if ($(this).attr("data-product-avail") == "true") {
      $(".product .add-soldout-text").text("Add To Cart");
      $(".product .product-form__buttons .product-form__submit").removeAttr(
        "disabled",
        ""
      );
    } else {
      $(".product .add-soldout-text").text("Sold Out");
      $(".product .product-form__buttons .product-form__submit").attr(
        "disabled",
        ""
      );
    }
    if ($(".product__info-wrapper").hasClass("commin-soon-product")) {
      $(".product .add-soldout-text").text("Coming Soon");
    }
    if ($(".product .product-form__buttons").hasClass("notify-popup-trigger")) {
      $(".product .add-soldout-text").text("COMING SOON - NOTIFY WHEN READY");
    }
  });
  $(".both-tab-bundle p.active-bundle-tab").trigger("click");
  $(document).on("click", ".apply-discount", function () {
    var discountCode = document.getElementById("discount_code").value;
    console.log(discountCode);
    $(this).addClass("disabled");
    // $('.discount_boxes').show();
    // $('.discount_code_remove').show();
    // $('.discount_boxes .discounr_code').text(discountCode);
    fetch("/discount/" + discountCode)
      .then(function () {
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {},
          }),
        })
          .then((cart) => {
            $("cart-drawer").load(location.href + " cart-drawer>*", "");
            $("a#cart-icon-bubble").load(
              location.href + " a#cart-icon-bubble>*",
              ""
            );
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
          });
        document.getElementById("discount_code").value = "";
      })
      .catch(function (error) {
        console.error("Error:", error);
      });
    setTimeout(function () {
      StampedFn.loadBadges({
        apiKey: "pubkey-zuPL67824ke4ulxeKDK2mFXPD29y3Q",
        sId: "224726",
      });
    }, 4000);
  });
  $(document).on("click", ".discount_code_remove", function () {
    fetch("/discount/CLEAR")
      .then(function () {
        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {},
          }),
        })
          .then((cart) => {
            $("cart-drawer").load(location.href + " cart-drawer>*", "");
            $("a#cart-icon-bubble").load(
              location.href + " a#cart-icon-bubble>*",
              ""
            );
          })
          .catch((error) => {
            console.error("Error updating cart:", error);
          });
        document.getElementById("discount_code").value = "";
      })
      .catch(function (error) {
        console.error("Error:", error);
      });
    setTimeout(function () {
      StampedFn.loadBadges({
        apiKey: "pubkey-zuPL67824ke4ulxeKDK2mFXPD29y3Q",
        sId: "224726",
      });
    }, 4000);
  });
  $(document).on("click", ".toggle-promo-code", function () {
    $(this).next().slideToggle();
  });
  $(document).on("click", ".selected-option-form", function () {
    $(".list-of-dropdown").not($(this).next()).slideUp();
    $(".selected-option-form").not($(this)).removeClass("active-dropdown-c");
    $(this).toggleClass("active-dropdown-c");
    $(this).next().slideToggle();
  });
  $(document).on("click", ".list-input-form label", function () {
    // $(this).parents(".contact-form-parent-dd").find(".selected-option-form p").text($(this).text());
    $(this).next().slideToggle();
  });
  if ($(window).width() < 750) {
    $(".cart-drawer__collection ul.product-grid").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendArrows: $(".cart-drawer__collection .slick-slider-nav"),
      appendDots: $(".cart-drawer__collection .slick-slider-dots"),
      centerMode: true,
      centerPadding: "89px",
      responsive: [
        {
          breakpoint: 360,
          settings: {
            centerPadding: "40px",
          },
        },
        {
          breakpoint: 321,
          settings: {
            centerPadding: "25px",
          },
        },
      ],
    });
    $(".product-ingredients-pdp .all-content-block-ingredients").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      infinite: false,
      appendArrows: $(".product-ingredients-pdp .slick-slider-nav"),
      appendDots: $(".product-ingredients-pdp .slick-slider-dots"),
      responsive: [
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1.23,
          },
        },
      ],
    });
  }
  $(document).on("click", ".product-details-sub", function () {
    var $cartItem = $(this).parents(".cart-item");
    $cartItem.addClass("remove");
    $cartItem = $(this).parents(".cart-item.remove");

    var drawersub, drawervar;

    if ($cartItem.find(".with-property").length > 0) {
      drawersub = $.trim(
        $cartItem.find(".with-property_revert_selling_plan dd").text()
      );
      drawervar = $.trim(
        $cartItem.find(".with-property_revert_product_id dd").text()
      );
    } else {
      drawersub = $(this).attr("data-cart-sub");
      drawervar = $(this).attr("data-cart-var");
    }

    var drawervarline = $cartItem.attr("data-line-attr");
    var datacartsub = $.trim($cartItem.attr("data-cart-sub") || "");
    var datacartprod = $.trim($cartItem.attr("data-cart-var") || "");

    $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: { quantity: 0, line: drawervarline },
      success: function (cart) {
        $.ajax({
          url: "/cart/add.js",
          type: "post",
          dataType: "json",
          data: {
            quantity: 1,
            id: drawervar,
            selling_plan: drawersub,
            properties: {
              _revert_selling_plan: datacartsub,
              _revert_product_id: datacartprod,
            },
          },
          success: function (cart) {
            $("cart-drawer").load(location.href + " cart-drawer>*", "");
            $("a#cart-icon-bubble").load(
              location.href + " a#cart-icon-bubble>*",
              ""
            );
          },
        });
      },
      error: function (err) {},
    });

    setTimeout(function () {
      StampedFn.loadBadges(".stamped-product-reviews-badge");
      if (
        $(".product-list-fre .single-product-block-fre.show-product").length ==
        2
      ) {
        $(".product-list-fre .single-product-block-fre")
          .not(".show-product")
          .addClass("hidden");
      } else if (
        $(".product-list-fre .single-product-block-fre.show-product").length ==
        1
      ) {
        $(".product-list-fre .single-product-block-fre")
          .not(".show-product")
          .first()
          .addClass("hidden");
      }
    }, 4000);
  });

  $(document).on("click", "#CartDrawer-Overlay", function (e) {
    $("cart-drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });

  $('a[href="#product-tabs-data"]').on("click", function (event) {
    event.preventDefault();

    var target = $($(this).attr("href"));
    if ($(window).width() < 990) {
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 65,
          },
          1000
        ); // Adjust the duration of the scroll animation as needed
      }
    } else {
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 100,
          },
          1000
        ); // Adjust the duration of the scroll animation as needed
      }
    }
  });

  if (
    $(".product-list-fre .single-product-block-fre.show-product").length == 2
  ) {
    $(".product-list-fre .single-product-block-fre")
      .not(".show-product")
      .addClass("hidden");
  } else if (
    $(".product-list-fre .single-product-block-fre.show-product").length == 1
  ) {
    $(".product-list-fre .single-product-block-fre")
      .not(".show-product")
      .first()
      .addClass("hidden");
  }
  if (
    $(
      ".thumbnail-slider .thumbnail-list.slider--tablet-up .thumbnail-list__item"
    )
      .first()
      .find("button")
      .attr("aria-current") == "true"
  ) {
    $(".product .custom-arrow.custom-prev-arrow").addClass("disabled-arrow");
  } else {
    $(".product .custom-arrow.custom-prev-arrow").removeClass("disabled-arrow");
  }
  if (
    $(
      ".thumbnail-slider .thumbnail-list.slider--tablet-up .thumbnail-list__item"
    )
      .last()
      .find("button")
      .attr("aria-current") == "true"
  ) {
    $(".product .custom-arrow.custom-next-arrow").addClass("disabled-arrow");
  } else {
    $(".product .custom-arrow.custom-next-arrow").removeClass("disabled-arrow");
  }
  $(document).on("click", ".product .custom-arrow", function (e) {
    if ($(this).hasClass("custom-prev-arrow")) {
      $(
        ".thumbnail-slider .thumbnail-list.slider--tablet-up .thumbnail-list__item button[aria-current='true']"
      )
        .parent()
        .prev()
        .find("button")
        .click();
    } else {
      $(
        ".thumbnail-slider .thumbnail-list.slider--tablet-up .thumbnail-list__item button[aria-current='true']"
      )
        .parent()
        .next()
        .find("button")
        .click();
    }
    if (
      $(
        ".thumbnail-slider .thumbnail-list.slider--tablet-up .thumbnail-list__item"
      )
        .first()
        .find("button")
        .attr("aria-current") == "true"
    ) {
      $(".product .custom-arrow.custom-prev-arrow").addClass("disabled-arrow");
    } else {
      $(".product .custom-arrow.custom-prev-arrow").removeClass(
        "disabled-arrow"
      );
    }
    if (
      $(
        ".thumbnail-slider .thumbnail-list.slider--tablet-up .thumbnail-list__item"
      )
        .last()
        .find("button")
        .attr("aria-current") == "true"
    ) {
      $(".product .custom-arrow.custom-next-arrow").addClass("disabled-arrow");
    } else {
      $(".product .custom-arrow.custom-next-arrow").removeClass(
        "disabled-arrow"
      );
    }
  });

  //for CC CRM
  $(".cta").mouseenter(function () {
    $(this).removeClass("bounce");
  });

  // Add mouse leave event handler
  $(".cta").mouseleave(function () {
    $(this).addClass("bounce");
  });
});
$(window).on("load resize", function (e) {
  if ($(window).width() < 750) {
    if (
      !$(".cart-drawer__collection ul.product-grid").hasClass(
        "slick-initialized"
      )
    ) {
      $(".cart-drawer__collection ul.product-grid").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        appendArrows: $(".cart-drawer__collection .slick-slider-nav"),
        appendDots: $(".cart-drawer__collection .slick-slider-dots"),
        centerMode: true,
        centerPadding: "89px",
        responsive: [
          {
            breakpoint: 360,
            settings: {
              centerPadding: "40px",
            },
          },
          {
            breakpoint: 321,
            settings: {
              centerPadding: "25px",
            },
          },
        ],
      });
    }
    if (
      !$(".product-ingredients-pdp .all-content-block-ingredients").hasClass(
        "slick-initialized"
      )
    ) {
      $(".product-ingredients-pdp .all-content-block-ingredients").slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        appendArrows: $(".product-ingredients-pdp .slick-slider-nav"),
        appendDots: $(".product-ingredients-pdp .slick-slider-dots"),
        responsive: [
          {
            breakpoint: 577,
            settings: {
              slidesToShow: 1.23,
            },
          },
        ],
      });
    }
  } else {
    if (
      $(".product-ingredients-pdp .all-content-block-ingredients").hasClass(
        "slick-initialized"
      )
    ) {
      $(".product-ingredients-pdp .all-content-block-ingredients").slick(
        "unslick"
      );
    }
    if (
      $(".cart-drawer__collection ul.product-grid").hasClass(
        "slick-initialized"
      )
    ) {
      $(".cart-drawer__collection ul.product-grid").slick("unslick");
    }
  }
});

const $notifyPopupTrigger = document.querySelector(
  ".product-form__buttons.notify-popup-trigger"
);

if ($notifyPopupTrigger) {
  $notifyPopupTrigger.addEventListener("click", function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "UgCT5U"]);
  });
}
